import { useCallback } from 'react';
import { BaseModal } from '../BaseModal/BaseModal';
import { Box, Button, Typography } from '@mui/material';
import { useIdleTimeout } from '~/hooks/useIdleTimeout';
import { useAppDispatch } from '~/store/appDispatch';
import { logout } from '~/store/users/thunks';
import { styles } from './styles';
import { formatTime } from '~/helpers/utils';

export const SessionWarningModal = () => {
  const dispatch = useAppDispatch();

  const handleLogoutClick = useCallback(async () => {
    try {
      await dispatch(logout());
    } catch (e) {
      console.error(e);
    }
  }, []);

  const { secondsLeft, stayActive, showWarning } = useIdleTimeout({ onTimeout: handleLogoutClick });

  if (!showWarning) return null;

  return (
    <BaseModal open={showWarning} containerProps={{ sx: { height: 'auto', padding: 3, gap: 1 } }}>
      <Typography variant="h6">Сеанс буде завершено</Typography>
      <Typography sx={{ textAlign: 'center' }}>
        Через відсутність активності сеанс буде автоматично завершено через 5 хвилин. Натисніть
        "Продовжити роботу", щоб залишитись у системі.
      </Typography>
      <Typography sx={styles.timerText}>{formatTime(secondsLeft)}</Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button variant="outlined" onClick={handleLogoutClick}>
          Вийти із системи
        </Button>
        <Button variant="contained" onClick={stayActive}>
          Продовжити роботу
        </Button>
      </Box>
    </BaseModal>
  );
};
